import Router from "vue-router";
import Raporty from "./components/Raporty";
import PremiaDlaZamowienia from "./components/PremiaDlaZamowienia";
import AuthService from "./shared/auth/auth.service.js";
import HotOferta from "./components/HotOferta";
import GreckieWakacje from "./components/GreckieWakacje";
import Bestseller from "./components/Bestseller";
import LecZaDarmo from "./components/LecZaDarmo";
import BestPromocja from "./components/BestPromocja";

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            redirect: "/premie-miesieczne"
        },
        {
            path: "/premie-miesieczne",
            name: "raport",
            component: Raporty,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/premia-dla-zamowienia",
            name: "premiaDlaZamowienia",
            component: PremiaDlaZamowienia,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/konkurs-hot-oferta",
            name: "konkursHotOferta",
            component: HotOferta,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/moje-greckie-wakacje",
            name: "greckieWakacje",
            component: GreckieWakacje,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/konkurs-bestseller",
            name: "bestseller",
            component: Bestseller,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/konkurs-best-promocja",
            name: "best-promocja",
            component: BestPromocja,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/lec-za-darmo",
            name: "lecZaDarmo",
            component: LecZaDarmo,
            meta: {
                requiresAuth: true
            }
        }
    ]
});
AuthService.useRouter(router);
export default router;
